//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import trackingParamsTypeaheadTemplate from '@legacy-components/common/universal-image-actions/tracking-params-typeahead.html';
import trackingParamsTypeaheadSuggestionNameTemplate from '@partials/tracking-params-typeahead-suggestion-name.html';
import trackingParamsTypeaheadSuggestionTemplate from '@partials/tracking-params-typeahead-suggestion.html';
import trackingParamsTypeaheadSuggestionNotFoundTemplate from '@partials/tracking-params-typeahead-suggestion-not-found.html';

import _ from "js/underscore-mixins";

(function() {
  const curalate = angular.module('curalate');
  curalate.component('trackingParamsTypeahead', {
    bindings: {
      paramName: '@?',
      inputName: '@?',
      modelName: '<',
      isRequired: '<',
      pattern: '@?',
      placeHolder: '@',
      findNames: '<?',
      onValueSelected: '&',
      onValueTyped: '&',
      isReadOnly: '<?',
      permissionNames: '@?',
      insufficientPermissions: '@?',
    },
    template: trackingParamsTypeaheadTemplate,
    controller: [
      '$scope',
      '$element',
      'TrackingParamsService',
      function(
                $scope,
                $element,
                TrackingParamsService,
            ) {
        const self = this;

        this.nameTemplate = trackingParamsTypeaheadSuggestionNameTemplate;
        this.defaultTemplate = trackingParamsTypeaheadSuggestionTemplate;
        this.emptyTemplate = trackingParamsTypeaheadSuggestionNotFoundTemplate;

        this.suggestTemplate = self.findNames ? self.nameTemplate : self.defaultTemplate;

        this.permissionsList = self.permissionNames ? [self.permissionNames] : [];

        this.paramSearchTypeahead = {
          currentQuery() {
            return self.modelName;
          },
          events: {
            enterKeyed($event, data) {
              if (data) {
                self.paramSearchTypeahead.context.onAdd($event, data);
              } else {
                const typeaheadElem = $element.find('.tt-input');
                typeaheadElem.typeahead('close');
              }
            },
          },
          context: {
            onAdd($event, data) {
              $scope.$broadcast('twitter-typeahead:reset');
              self.onValueSelected({ data });
              self.setModel(data);
            },
          },
          templates: {
            suggestion: {
              html: self.suggestTemplate,
            },
            empty: {
              html: self.emptyTemplate,
            },
          },
          searchParams: _.debounce((query, defer) => {
            self.outstandingAsyncAction = 'search';
            self.paramNameArg = self.paramName || null;
            TrackingParamsService.searchTrackingParams(query, self.paramNameArg, self.findNames).then((data) => {
              defer.resolve(data);
              self.outstandingAsyncAction = null;
            }).catch(() => {
              defer.resolve([]);
            }).finally(() => {
              self.outstandingAsyncAction = null;
            });
          }, 200),
        };

        this.setModel = function(data) {
          const typeaheadElem = $element.find('.tt-input');
          if (self.findNames) {
            typeaheadElem.typeahead('val', data.name);
            self.modelName = data.name;
            typeaheadElem.typeahead('close');
          } else {
            typeaheadElem.typeahead('val', data.value);
            self.modelName = data.value;
            typeaheadElem.typeahead('close');
          }
        };

        this.updateSuggestion = function() {
          const typed = self.modelName;
          self.onValueTyped({ typed });
        };
      },
    ],
  });
})();
